// extracted by mini-css-extract-plugin
export default {"switchPause":"domainSettingsModal_switchPause__Ycm6G","pauseWrapper":"domainSettingsModal_pauseWrapper__jZHes","hint":"domainSettingsModal_hint__Alnic"};